import React from 'react';
import { useTranslation } from 'react-i18next';
import { Td, EditableCell, PriceInput, ActionButtons, IconButton } from '../PriceListsPage.style';
import formatCurrency from '../../../lib/formatCurrency';

const TyreTableRow = ({
  tyre,
  pricelistKey,
  editingPrice,
  onPriceEdit,
  onSavePrice,
  onEdit,
  onDelete,
  onEditingPriceChange,
}) => {
  const { t } = useTranslation();

  const handleBlur = (field, value) => {
    onEditingPriceChange(null);
    // Save to server
    if (onSavePrice) {
      onSavePrice(tyre.id, field, value);
    }
  };

  const renderPriceCell = (field, value) => {
    const editingKey = `${tyre.id}-${field}`;
    const isEditing = editingPrice === editingKey;
    const numValue = parseFloat(value) || 0;

    return (
      <EditableCell
        $editing={isEditing}
        onClick={() => onEditingPriceChange(editingKey)}
      >
        {isEditing ? (
          <PriceInput
            type="number"
            step="0.01"
            value={numValue}
            onChange={(e) => onPriceEdit(pricelistKey, tyre.id, field, e.target.value)}
            onBlur={() => handleBlur(field, numValue)}
            autoFocus
          />
        ) : (
          formatCurrency(value)
        )}
      </EditableCell>
    );
  };

  return (
    <tr>
      <Td>{tyre.catalogNumber || '-'}</Td>
      <Td>{tyre.ean || '-'}</Td>
      <Td style={{ fontWeight: 600 }}>{tyre.dimension || '-'}</Td>
      <Td>{tyre.model || '-'}</Td>
      <Td>{renderPriceCell('bruto', tyre.bruto)}</Td>
      <Td>{renderPriceCell('neto', tyre.neto)}</Td>
      <Td>{renderPriceCell('brutoZPopustom', tyre.brutoZPopustom)}</Td>
      <Td>
        <ActionButtons>
          <IconButton
            onClick={() => onEdit(pricelistKey, tyre)}
            title={t('edit')}
          >
            <i className="mdi mdi-pencil-outline" />
          </IconButton>
          <IconButton
            onClick={() => onDelete(pricelistKey, tyre.id)}
            title={t('delete')}
          >
            <i className="mdi mdi-delete-outline" />
          </IconButton>
        </ActionButtons>
      </Td>
    </tr>
  );
};

TyreTableRow.displayName = 'TyreTableRow';

export default TyreTableRow;
